module.exports = __webpack_public_path__ + "static/media/ls.5204fdf2.svg";